/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeviceTypeListResponseDto = {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  status: DeviceTypeListResponseDto.status;
  createdAt: string;
  updatedAt: string;
  version: number;
};
export namespace DeviceTypeListResponseDto {
  export enum status {
    ACTIVE = 'ACTIVE',
    DELETION_IN_PROGRESS = 'DELETION_IN_PROGRESS',
  }
}

